import { getAudioGraph } from '../helpers/get-audio-graph';
export const getAudioNodeConnections = (anyAudioNode) => {
    // The builtin types define the context property as BaseAudioContext which is why it needs to be casted here.
    const audioGraph = getAudioGraph(anyAudioNode.context);
    const audioNodeConnections = audioGraph.nodes.get(anyAudioNode);
    if (audioNodeConnections === undefined) {
        throw new Error('Missing the connections of the given AudioNode in the audio graph.');
    }
    return audioNodeConnections;
};
//# sourceMappingURL=/build/es2018/helpers/get-audio-node-connections.js.map